/**
 * Builds the runtime question model without dropping media returned by the API.
 * Keeping the original question spread is important for imagenUrl and future
 * non-answer fields used by the student runner.
 */
export function prepareTestQuestions(questions, shuffle) {
  if (!Array.isArray(questions)) return [];
  const shuffleAnswers = typeof shuffle === "function" ? shuffle : (values) => values;
  return questions.map((question) => {
    const answers = Array.isArray(question?.respuestas) ? question.respuestas : [];
    const respuestasMezcladas = answers.map((texto, index) => ({
      texto,
      esCorrecta: index === question.correcta,
      indiceOriginal: index,
    }));
    return {
      ...question,
      imagenUrl: typeof question?.imagenUrl === "string" ? question.imagenUrl.trim() : "",
      respuestasMezcladas: shuffleAnswers(respuestasMezcladas),
    };
  });
}
